import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const categoryLinks = [
  { slug: '911-baoliao', name: '911爆料' },
  { slug: '51-baoliao', name: '51爆料' },
  { slug: '91-baoliao', name: '91爆料' },
  { slug: 'yule-bagua', name: '娱乐八卦' },
  { slug: 'wanghong-heiliao', name: '网红黑料' },
  { slug: 'meiri-baoliao', name: '每日爆料' },
];

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 no-underline whitespace-nowrap cursor-pointer"
          >
            <span className="text-xl md:text-2xl font-heading font-bold text-primary-500">
              {t('common:site.name')}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              {t('common:nav.home')}
            </Link>

            <div
              className="relative"
              onMouseEnter={() => setCategoryOpen(true)}
              onMouseLeave={() => setCategoryOpen(false)}
            >
              <button
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 flex items-center gap-1 ${
                  location.pathname.startsWith('/category')
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {t('common:nav.categories')}
                <i className={`ri-arrow-down-s-line text-xs transition-transform duration-200 ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {categoryOpen && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2">
                  <div className="bg-background-50 border border-background-200/70 rounded-lg py-2 min-w-[160px]">
                    {categoryLinks.map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        className="block px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 whitespace-nowrap cursor-pointer transition-colors"
                      >
                        {cat.name}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Link
              to="/category/meiri-baoliao"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                location.pathname === '/category/meiri-baoliao'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              {t('common:nav.hot')}
            </Link>

            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              {t('common:nav.about')}
            </Link>
          </div>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer text-foreground-700"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            <Link
              to="/"
              className={`block py-2 text-sm font-medium cursor-pointer ${
                location.pathname === '/' ? 'text-primary-500' : 'text-foreground-700'
              }`}
            >
              {t('common:nav.home')}
            </Link>
            <div className="py-2 text-sm font-medium text-foreground-700">
              {t('common:nav.categories')}
            </div>
            {categoryLinks.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="block py-2 pl-4 text-sm text-foreground-600 hover:text-primary-500 cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`block py-2 text-sm font-medium cursor-pointer ${
                location.pathname === '/about' ? 'text-primary-500' : 'text-foreground-700'
              }`}
            >
              {t('common:nav.about')}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}